import { FC, useMemo } from 'react';
import { pushInternalURL } from 'src/functions/functions';
import useResponsive from 'src/hooks/contexts/useResponsive';
import Flex from 'src/styles/layouts/Flex';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import NGButton from 'src/styles/theme/components/NGButton';
import NGHeading from 'src/styles/theme/components/NGHeading';
import { EFontFamily, ETextType } from 'src/styles/theme/components/NGText/NGText.enum';
import { ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { ISliderInformation } from './SlideInformation.type';
import { FlexEx } from './SliderInformation.styles';

const SliderInformation: FC<ISliderInformation & { isVisible?: boolean }> = ({
	url,
	isExternalUrl,
	title,
	subTitle,
	labelButton,
	isVisible
}) => {
	const { isSmallerThanSm, isSmallerThanMd } = useResponsive();

	const formattedUrl = useMemo(() => {
		if (!url.startsWith('http')) {
			return;
		}

		if (!isExternalUrl) {
			const baseUrl = new URL(url);
			return `${baseUrl.pathname}${baseUrl.search}`;
		}

		return url;
	}, [isExternalUrl, url]);

	return (
		<FlexEx vertical={EFlex.end} gap={ESize.m} isVisible={isVisible} padding={ESize['4xs']} mdPadding={ESize['5xs']}>
			<Flex direction={EFlex.column}>
				<NGHeading type={ETextType.h4} textColor={ETextColor.gold}>
					{subTitle}
				</NGHeading>

				<NGHeading
					as='p'
					className='content-label'
					type={isSmallerThanSm ? ETextType.h3 : ETextType.h2}
					fontFamily={EFontFamily.cinzel}
				>
					{title}
				</NGHeading>
			</Flex>

			{!isSmallerThanMd && formattedUrl ? (
				isExternalUrl ? (
					<a href={url} target='_blank' rel='noopener noreferrer'>
						<NGButton size={ESize.s} marginBottom={ESize['5xs']}>
							{labelButton}
						</NGButton>
					</a>
				) : (
					<NGButton size={ESize.s} marginBottom={ESize['5xs']} onClick={() => pushInternalURL(formattedUrl)}>
						{labelButton}
					</NGButton>
				)
			) : null}
		</FlexEx>
	);
};

export { SliderInformation };
